import { connect } from 'react-redux';

import { getIsMobile, getIsHotelOnly } from 'src/store/view/selectors';
import {
  isExpandableMapSelector,
  isExpandedMapSelector,
  popupDataWithHotelInfoSelector,
} from '../../../../store/map/selectors';

import { HotelPopupv2 } from '../../../MapboxSearch/components/HotelPopupv2';

import { resetPopupData } from '../../../../store/map/slice';

const mapStateToProps = (state) => ({
  popupData: popupDataWithHotelInfoSelector(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
  isExpandedMap: isExpandedMapSelector(state),
  isExpandableMap: isExpandableMapSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  resetPopupDataHandler: () => dispatch(resetPopupData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelPopupv2);
